// Based on src\app\shared\services\api-journey-planner\models\enumerations.ts
export enum LocationType {
  unknown = 'unknown',
  stopArea = 'stoparea',
  stopPoint = 'stoppoint',
  address = 'address',
  pointOfInterest = 'pointofinterest',
  metaStation = 'metastation',
  // currentPosition = 'currentPosition', // NOT an actual api journey planner type. Do not use against api journey planner
}

export class LocationTypeHelper {
  public static parse(value: string): LocationType {
    if (value in LocationType) {
      return LocationType[value as keyof typeof LocationType];
    }
    return LocationType.unknown;
  }
}
